import AskModal from "../common/AskModal";

const AskRemoveModal = ({ visible, onConfirm, onCancel }) => {

    return (
        <AskModal visible={visible} title="타워 삭제" description="타워를 삭제하시겠습니까?" confirmText="삭제" cancelText="취소" onConfirm={onConfirm} onCancel={onCancel} />
    );
};

export default AskRemoveModal;